import React from 'react';
import {
  calculatePatientAge,
  getPatientProfileCompletion,
  patientProfileSections,
  priorityGroupOptions,
  sexOptions,
} from '../clinical/patientProfile';

const PatientProfileForm = ({
  profile,
  onChange,
  onSave,
  errors = [],
  saveMessage = '',
  readOnly = false,
  compact = false,
}) => {
  const completion = getPatientProfileCompletion(profile);

  const updateField = (field, value) => {
    if (readOnly) return;
    if (field === 'birthDate') {
      onChange({ ...profile, birthDate: value, age: calculatePatientAge(value) });
      return;
    }
    onChange({ ...profile, [field]: value });
  };

  const renderInput = (label, field, type = 'text', placeholder = '') => (
    <label className="patient-profile-field">
      <span>{label}</span>
      <input
        type={type}
        value={profile[field] || ''}
        onChange={(event) => updateField(field, event.target.value)}
        placeholder={placeholder}
        disabled={readOnly || field === 'age'}
      />
    </label>
  );

  const renderTextarea = (label, field, placeholder = '') => (
    <label className="patient-profile-field patient-profile-field-wide">
      <span>{label}</span>
      <textarea
        value={profile[field] || ''}
        onChange={(event) => updateField(field, event.target.value)}
        placeholder={placeholder}
        rows={compact ? 2 : 3}
        disabled={readOnly}
      />
    </label>
  );

  const renderSelect = (label, field, options) => (
    <label className="patient-profile-field">
      <span>{label}</span>
      <select
        value={profile[field] || ''}
        onChange={(event) => updateField(field, event.target.value)}
        disabled={readOnly}
      >
        <option value="">Seleccionar</option>
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </label>
  );

  return (
    <div className={`patient-profile-module ${compact ? 'compact' : ''}`}>
      <div className="patient-profile-header">
        <div>
          <h3>Ficha del paciente</h3>
          <p>Datos clinicos y administrativos base para admision, consulta y seguimiento.</p>
        </div>
        <div className="patient-profile-progress">
          <strong>{completion.percentage}%</strong>
          <span>{completion.completed}/{completion.total} obligatorios</span>
        </div>
      </div>

      {errors.length > 0 && (
        <div className="patient-profile-errors">
          <strong>Campos pendientes</strong>
          <ul>
            {errors.map((error) => <li key={error}>{error}</li>)}
          </ul>
        </div>
      )}

      <div className="patient-profile-sections">
        <section>
          <h4>{patientProfileSections[0].title}</h4>
          <div className="patient-profile-grid">
            {renderInput('Nombre completo', 'name', 'text', 'Nombre y apellidos')}
            {renderInput('Tipo documento', 'documentType')}
            {renderInput('Documento identificacion', 'documentId')}
            {renderInput('Historia clinica unica', 'clinicalHistoryNumber')}
            {renderInput('Fecha nacimiento', 'birthDate', 'date')}
            {renderInput('Edad', 'age')}
            {renderSelect('Sexo', 'sex', sexOptions)}
          </div>
        </section>

        <section>
          <h4>{patientProfileSections[1].title}</h4>
          <div className="patient-profile-grid">
            {renderInput('Telefono', 'phone', 'tel')}
            {renderInput('Correo electronico', 'email', 'email')}
            {renderInput('Provincia', 'province')}
            {renderInput('Ciudad / canton', 'city')}
            {renderInput('Direccion', 'address')}
          </div>
        </section>

        <section>
          <h4>{patientProfileSections[2].title}</h4>
          <div className="patient-profile-grid">
            {renderTextarea('Antecedentes personales', 'medicalHistory', 'Enfermedades, cirugias, hospitalizaciones relevantes')}
            {renderTextarea('Antecedentes familiares', 'familyHistory', 'Hipertension, diabetes, cancer u otros antecedentes familiares')}
            {renderTextarea('Alergias', 'allergies', 'Medicamentos, alimentos u otras alergias')}
            {renderTextarea('Medicamentos actuales', 'currentMedications', 'Nombre, dosis y frecuencia')}
          </div>
        </section>

        <section>
          <h4>{patientProfileSections[3].title}</h4>
          <div className="patient-profile-grid">
            {renderSelect('Discapacidad', 'disability', ['No', 'Si'])}
            {renderInput('Detalle discapacidad', 'disabilityDetail', 'Tipo, porcentaje o apoyo requerido')}
            {renderSelect('Grupo prioritario', 'priorityGroup', priorityGroupOptions)}
          </div>
        </section>

        <section>
          <h4>{patientProfileSections[4].title}</h4>
          <div className="patient-profile-grid">
            {renderInput('Contacto emergencia', 'emergencyContact')}
            {renderInput('Parentesco / relacion', 'emergencyRelationship')}
            {renderInput('Telefono emergencia', 'emergencyPhone', 'tel')}
          </div>
        </section>
      </div>

      {!readOnly && (
        <div className="patient-profile-actions">
          <button className="btn btn-primary" type="button" onClick={onSave}>
            Guardar ficha del paciente
          </button>
          {saveMessage && <span className="save-message">{saveMessage}</span>}
        </div>
      )}
    </div>
  );
};

export default PatientProfileForm;
